module.exports = __webpack_public_path__ + "static/img/life-style5.f40ede55.png";